import React from 'react';
import BackedItem from "./BackedItem";

function BackList(props) {
    const {order, incrementQuantity, decrQuantity} = props;
    const totalPrise = order.reduce((sum, el) => {
        return sum + el.price * el.quantity
    }, 0)
    return (
        <div className="bsk">
            <ul className="collection backed-list">
                <li className="collection-item active">
                    Backed
                </li>
                {order.length ? order.map(item => {
                    return(
                        <BackedItem
                            key={item.id}
                            {...item}
                            removeBacked={props.removeBacked}
                            incrementQuantity={incrementQuantity}
                            decrQuantity={decrQuantity}
                        />
                    )
                }) : <li className="collection-item">Backed is empty</li> }
                <li className="collection-item active">
                    Total Prise: {totalPrise} <b>$</b>
                </li>
                <i className="material-icons basket-close" onClick={props.handlBasjedShow}>close</i>
            </ul>
        </div>
    );
}

export default BackList;